import React from 'react';

const FundingCard = ({ title, description, items, icon }) => {
  return (
    <>
      <div className="card bg-white h-100 p-4 card-hover-pop mx-2" style={{ borderRadius: '14px' }}>
        <div className="d-flex flex-column h-100">
          <div className="text-center mb-4">
            <span
              className="d-inline-flex align-items-center justify-content-center rounded-circle bg-light text-primary mx-auto"
              style={{ width: '48px', height: '48px' }}
            >
              {icon}
            </span>
          </div>

          <div className="text-center">
            <h3 className="font-weight-semibold mb-3" style={{ color: '#000000', fontSize: '1.25rem' }}>{title}</h3>
            <p className="text-muted mb-4" style={{ fontSize: '.9rem', fontWeight: 400 }}>{description}</p>
          </div>

          <ul className="list-unstyled">
            {items.map((item, index) => (
              <li key={index} className="d-flex align-items-start mb-2 text-muted">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="text-primary mt-1 me-2 flex-shrink-0 px-1"
                >
                  <path d="M20 6 9 17l-5-5" />
                </svg>
                <span className="text-muted ms-2 d-flex">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default function UplyftInfoLanding() {
  const data = [
    {
      title: 'Financiamiento Flexible',
      description: 'Accede a capital de trabajo adaptado a las necesidades de tu negocio',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" strokeWidth="2" width="24" height="24" viewBox="0 0 24 24">
          <path d="M12 1v22M5 6h14M5 12h14M5 18h14" />
        </svg>
      ),
      items: [
        'Financiamiento de hasta $5,000,000',
        'Sin pagos mensuales fijos',
        'Usa los fondos para cualquier necesidad empresarial'
      ]
    },
    {
      title: 'Capital de Crecimiento',
      description: 'Impulsa tu expansión con acceso fácil a fondos',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" strokeWidth="2" width="24" height="24" viewBox="0 0 24 24">
          <path d="M3 17l6-6 4 4 8-8" />
          <path d="M14 7h7v7" />
        </svg>
      ),
      items: [
        'Proceso de aprobación rápido',
        'Planes de pago personalizados',
        'Equipo de soporte dedicado'
      ]
    },
    {
      title: 'Financiamiento Puente',
      description: 'Fondos temporales mientras esperas flujo de efectivo futuro',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" strokeWidth="2" width="24" height="24" viewBox="0 0 24 24">
          <path d="M4 17v-7a4 4 0 0 1 8 0v7" />
          <path d="M12 17v-3a4 4 0 0 1 8 0v3" />
        </svg>
      ),
      items: [
        'Apoyo a corto plazo',
        'No se requiere garantía',
        'Desembolso rápido'
      ]
    },
    {
      title: 'Financiamiento de Equipos',
      description: 'Financia nuevas herramientas para hacer crecer tu negocio',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" strokeWidth="2" width="24" height="24" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="10" />
          <path d="M12 6v6l4 2" />
        </svg>
      ),
      items: [
        'Financiamiento específico para equipos',
        'Pagos deducibles de impuestos',
        'Plazos de hasta 5 años'
      ]
    }
  ];

  return (
    <div>
      <div className="row mt-8rem">
        <div className="col-12 col-lg-12 text-center">
          <h1 style={{ color: '#000000' }}>
            Soluciones de Financiamiento Simples y Flexibles
          </h1>
          <p className="text-muted">
            Obtén el capital de trabajo que necesitas con nuestro programa simplificado de adelantos de efectivo para comerciantes. Aprobaciones rápidas, términos flexibles y financiamiento de hasta $5,000,000.
          </p>
        </div>
      </div>
      <div className="row mt-8rem p-4">
        {data.map((tier, idx) => (
          <div key={idx} className="col-md-6 col-lg-3 mb-4 p-0">
            <FundingCard {...tier} />
          </div>
        ))}
      </div>
    </div>
  );
}
